import { IColumns } from '../../../../../components/Dashboard/TableSmall/TableTypes'

export interface IData {
  request: string
  columns: IColumns[]
}

export const data: IData = {
  request: 'staking/balance',
  columns: [
    {
      id: 'asset',
      label: 'ASSET',
    },
    {
      id: 'amount',
      label: 'AMOUNT',
    },
  ],
}

export const stateData = [
  { asset: 'ETH', amount: '$250,00' },
  { asset: 'BNB', amount: '$1000' },
]
